import { FacturaDetalle } from './FacturaDetalle';

export class FacturaXls {
    id:number;
fecha:string;
   cedula:string;
   cliente:string;
   codigo_producto:string;
   producto:string;
   cantidad:number;
   iva:number;
   pvp:number;
   ruta:string;
   error:string;
   autorizacion:string;
   numeroDoc:string;
   idEmisor:number;
   email:string;
    }
    